<template>
  <BigNumberParent>
    <div class="mapcontainer">
      <div class="headbox">
        <h6>Meiste neue Fälle</h6>
        <p class="subheadline">Im Vergleich zum Vortag</p>
      </div>

      <div class="pointbox">
        <ul class="points">
          <template v-for="point in highlight_points.features"
            ><li :key="point.properties.name" class="hotspot">
              <b></b>&nbsp;{{ point.properties.name }}
            </li></template
          >
        </ul>
      </div>

      <svg :width="map_width" :height="map_height" ref="svg">
        <path :d="austria_shape" :fill="texture.url()" class="austria"></path>
        <path
          :d="highlight_points_geo"
          class="highlight_points"
          :fill="texture_orange.url()"
        ></path>
      </svg>
      <div
        class="map_height_proxy"
        :style="{ height: `${map_height}px` }"
      ></div>
    </div>
  </BigNumberParent>
</template>

<script>
import BigNumberParent from "./BigNumberParent.vue";
import ComponentSizeMixin from "./ComponentSizeMixin";
import geo_austria_simple from "../data/austria_simple.geo.json";
import * as geo from "d3-geo";
import textures from "textures";
import * as selection from "d3-selection";
import moment from "moment";

export default {
  name: "AustriaMapPoints",
  props: ["highlight_points", "mobile"],
  components: { BigNumberParent },
  mixins: [ComponentSizeMixin],
  data: () => ({
    deeplink_relative: true,
    texture: textures
      .circles()
      .fill("white")
      .radius(2)
      .size(6),
    texture_orange: textures
      .circles()
      .fill("rgb(252, 144, 42)")
      .radius(2)
      .size(6)
  }),
  mounted() {
    selection.select(this.$refs.svg).call(this.texture);
    selection.select(this.$refs.svg).call(this.texture_orange);
  },
  methods: {},
  computed: {
    map_width() {
      if (this.componentWidth < 400) {
        return Math.min(this.componentWidth, 200);
      }
      return Math.min(this.componentWidth, 225);
    },
    map_height() {
      return Math.floor(this.map_width / 2);
    },
    projection() {
      return geo.geoMercator().fitExtent(
        [
          [0, 0],
          [this.map_width, this.map_height]
        ],
        geo_austria_simple
      );
    },
    geoPath() {
      return geo
        .geoPath()
        .projection(this.projection)
        .pointRadius(8);
    },
    stand() {
      return moment(
        this.highlight_points.features[0].properties.stand,
        "YYYY-MM-DD HH:mm"
      ).format("D.M.");
    },
    austria_shape() {
      return this.geoPath(geo_austria_simple);
    },
    highlight_points_geo() {
      return this.geoPath(this.highlight_points);
    },
    labels_preposition() {
      var labels = this.highlight_points.features.map((d, i) => {
        var proj = this.projection(d.geometry.coordinates);
        return {
          x: proj[0],
          y: proj[1],
          name: `${i + 1}`,
          width: 5,
          height: 10,
          r: 8
        };
      });
      return labels;
    }
  }
};
</script>
<style scoped>
.mapcontainer {
  position: relative;
}

svg {
  position: absolute;
  right: 0px;
  top: 3px;
}

.map_height_proxy {
  padding-bottom: 15px;
}

.headbox {
  position: absolute;
  max-width: 55%;
}

.pointbox {
  position: absolute;
  left: 0px;
  max-width: 43%;
  bottom: 0px;
  text-indent: -8px;
  padding-left: 8px;
}

ul.points {
  list-style-type: none;
  line-height: 1.1em;
  margin: 0;
  padding: 0;
}

ul.points li {
  list-style-type: none;
  line-height: 1.1em;
  margin: 0;
  padding: 0;
}

ul.points li::before {
  display: none;
}

h6 {
  color: white;
  text-align: left;
  font-size: 18px;
  margin: 0;
  line-height: 18px;
  margin-bottom: 2px;
}
p,
ul,
li {
  font-size: 10px;
  margin: 0;
  text-align: left;
  line-height: 12px;
}

.headbox p {
  display: block;
  margin-top: -2px;
  line-height: 1em;
}

.bignumber {
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 700px) {
  .cmc_normal .map_height_proxy {
    padding-bottom: 0;
  }
  .cmc_normal p,
  .cmc_normal ul.points,
  .cmc_normal ul.points li {
    font-size: 11px;
    line-height: 13px;
  }
  .cmc_normal ul.points,
  .cmc_normal ul.points li,
  .cmc_normal p {
    line-height: 13px;
  }
}

li b {
  text-align: center;
  font-weight: normal;
  display: inline-block;
  background: rgb(252, 144, 42);
  width: 6px;
  height: 6px;
  font-size: 12px;
  color: white;
  border-radius: 16px;
  padding-top: 2px;
  margin-top: -2px;
  box-sizing: border-box;
}
</style>
